import React from 'react';

const OrderedListIcon = props => (
  <svg viewBox="0 0 16 16" style={{ fillRule: 'evenodd' }} {...props}>
    <path
      stroke="none"
      d="M264,74H254a1,1,0,0,1,0-2h10A1,1,0,1,1,264,74Zm0-6H254a1,1,0,0,1,0-2h10A1,1,0,1,1,264,68ZM249,80h2V79h1v2h-3V80Zm1-2h-1V77h3v1h-1v1h-1V78Zm-1-4h1V73h1v1h1v1h-3V74Zm0-2V71h3v2h-1V72h-2Zm1-6h-1V65h2v4h-1V66Zm4,12h10a1,1,0,0,1,0,2H254A1,1,0,0,1,254,78Z"
      transform="translate(-249 -65)"
    />
  </svg>
);

export default OrderedListIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/ordered-list-icon.js